import React from 'react';
interface SizeSelectorProps {
  sizes: string[];
  selectedSize: string;
  onSizeChange: (size: string) => void;
}
export const SizeSelector: React.FC<SizeSelectorProps> = ({
  sizes,
  selectedSize,
  onSizeChange
}) => {
  return <div className="mt-6" data-id="element-318">
      <div className="flex items-center justify-between" data-id="element-319">
        <h3 className="text-sm font-medium text-gray-900" data-id="element-320">Size</h3>
        <button className="text-sm font-medium text-fuchsia-600 hover:text-fuchsia-500 transition-colors" data-id="element-321">
          Size Guide
        </button>
      </div>
      <div className="grid grid-cols-5 gap-2 mt-2" data-id="element-322">
        {sizes.map(size => <button key={size} className={`
              flex items-center justify-center rounded-md border py-2 px-3 text-sm font-medium uppercase
              focus:outline-none focus:ring-2 focus:ring-fuchsia-500 focus:ring-offset-1
              ${selectedSize === size ? 'border-transparent bg-fuchsia-600 text-white hover:bg-fuchsia-700' : 'border-gray-300 bg-white text-gray-900 hover:bg-gray-50'}
              transition-colors duration-200
            `} onClick={() => onSizeChange(size)} aria-label={`Select size ${size}`} data-id="element-323">
            {size}
          </button>)}
      </div>
    </div>;
};